<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2020-12-21 15:06:24
 * @LastEditors: xzx
 * @LastEditTime: 2020-12-26 11:45:25
-->
<template>
    <Badge :value="text || 'new'" :severity="type" :size="size">
        <slot></slot>
    </Badge>
</template>

<script>
import { ref, watch } from 'vue'
import Badge from 'primevue/badge';

export default {
    name: 'tw-badge',
    components: {
        Badge
    },
    setup(props, context) {
        const text = ref(props.value);

        watch(text, (newValue) => {
            context.emit('update:value', newValue)
        })

        return {
            text
        }
    },
    props: {
        value: {
            type: Number,
            value: 0
        },
        type: String,
        size: String
    }
}
</script>
